<template>
  <div>
    <DsSectionQuote
      v-if="pageContent.quote.image && pageContent.quote.description"
      class="ds-margin-bottom-48 ds-md-margin-bottom-96"
      :with-logo="false"
      with-text-size-medium
      v-bind="pageContent.quote"
      :screen="screen"
    />
    <div
      v-if="pageNavigationList.length"
      class="sticky-top ds-width-full"
    >
      <DsOnPageNavigation
        disposition="horizontal"
        :items="pageNavigationList"
        :screen="screen"
        :title="labels.onThisPage"
        update-route
        :button="downloadPDFLink.link"
        portal-target="header"
        :initial-active-item="$route.hash"
        :event-data="{ 'dropdown-opened': { setScrollTop: null } }"
        use-grid
      />
    </div>
    <section
      class="ds-container ds-margin-y-48 ds-md-margin-y-96"
      data-id="intro"
    >
      <div class="ds-grid">
        <div class="ds-grid__col ds-grid__col--12 ds-md-grid__col--10 ds-lg-grid__col--6 ds-lg-grid__col--offset-1">
          <h2 class="ds-heading ds-color-green ds-margin-bottom-24">
            {{ pageContent.report.title }}
          </h2>
          <RichText :data="pageContent.report.text" />
          <p class="ds-font-weight-bold ds-color-green ds-margin-top-24">
            {{ pageContent.report.signature }}
          </p>
        </div>
      </div>
    </section>
    <DsSectionImage
      theme-variant="light-dark"
      :image="pageContent.image"
      :screen="screen"
      is-contained
    />
    <section data-id="summary">
      <InvestorRelationsFinancialBlockCollection
        v-if="pageContent.financialData"
        :title="pageContent.summary.title"
        :financial-data="pageContent.financialData"
        :usp-data="pageContent.summary.usps"
        :year="pageContent.year"
        :show-line-chart="pageContent.financialData.fullYearData.length === 4"
        :footnote="pageContent.summary.footnote"
        class="ds-padding-y-48 ds-md-padding-y-96"
        theme="dark"
      />
    </section>
    <DsCallToAction
      alignment="left"
      with-title-size-large
      :title="downloadPDFLink.title"
      :subtitle="downloadPDFLink.subtitle"
      :primary-link="downloadPDFLink.link"
    />
  </div>
</template>

<script setup>
import { DsCallToAction, DsOnPageNavigation, DsSectionImage, DsSectionQuote } from 'awds'
const { labels } = useInvestorsGlobalData()
const { screen } = useScreen()

const props = defineProps({
  pageContent: { type: Object, required: true }
})

const pageNavigationList = computed(() => {
  const items = [
    { label: props.pageContent.report.title, slug: 'intro' },
    { label: props.pageContent.summary.title, slug: 'summary' }
  ]
  return items
})

const downloadPDFLink = computed(() => {
  if (!props.pageContent.downloadPDF) {
    return null
  }
  return {
    title: labels.value.download,
    subtitle: props.pageContent.title,
    link: {
      ...props.pageContent.downloadPDF,
      iconLeft: { name: 'download', category: 'arrows' },
      title: labels.value.downloadPdf
    }
  }
})
</script>
